<script>
export default {
  props: {
    color: {
      type: String,
      default: 'yellow',
    },
  },
}
</script>

<template>
  <div
    class="p-4 rounded"
    :class="{
      'bg-red-300': color === 'red',
      'bg-yellow-300': color === 'yellow',
      'bg-green-300': color === 'green',
    }"
  >
    <slot />
  </div>
</template>
